const { Core, Utils } = Global;
const { $active } = Utils;

const SPOT_SEL = '[data-spot]'

customElements.define('hot-spots', class extends Core {
    elements = {
        $: [['mobile-label'], ['trigger'], 'stage']
    }

    render() {
        // This event will be trigger only on mobile, because 'mobile-label' unclickable on desktop
        this.$('mobile-label', {
            click: this._handleMobileLabelClick 
        })

        this.$('trigger', {
            change: this._handleChange
        });

        this.$('stage', {
            click: this._handleImageClick
        });

      var _this = this;
      var sectionContainer = _this.closest('.hot-spots-section-container');
      var sectionBody = _this.closest('.hot_spots_section_body');
      var imageWrapper = sectionContainer.querySelector('.hot-spots-stage-wrapper');
      var imageInner = sectionContainer.querySelector('.hot-spots-stage-inner');
      var hotSpots = this.closest('.shopify-section').querySelectorAll('[data-spot]');
      var leftArrow = sectionContainer.querySelector('.left-arrow');
      var rightArrow = sectionContainer.querySelector('.right-arrow');

      if(imageWrapper && leftArrow && rightArrow){
        imageWrapper.addEventListener('scroll',function(event) {
        var scrollLeft = imageWrapper.scrollLeft;
        if(scrollLeft == window.innerWidth){
          leftArrow.removeAttribute("hidden");
          rightArrow.setAttribute("hidden","");
        }else if(scrollLeft == 0){
           rightArrow.removeAttribute("hidden");
           leftArrow.setAttribute("hidden","");
        }
      });
      }
      
        // let throttleTimer;
        // const throttle = (callback, time) => {
        // if (throttleTimer) return;
        // throttleTimer = true;
        // setTimeout(() => {
        //   callback();
        //   throttleTimer = false;
        // }, time);
        // }

      //  function throttle(callback) {
      //     let requestId = null, lastArgs;
      //     const later = context=>()=>{
      //         requestId = null,
      //         callback.apply(context, lastArgs)
      //     }
      //       , throttled = (...args)=>{
      //         lastArgs = args,
      //         requestId === null && (requestId = requestAnimationFrame(later(this)))
      //     }
      //     ;
      //     return throttled.cancel = ()=>{
      //         cancelAnimationFrame(requestId),
      //         requestId = null
      //     }
      //     ,
      //     throttled
      // }

      
      //   function handleScrollAnimation(){
      //     if (window.innerWidth < 481) {     
      //     console.log("111");
      //     if (sectionContainer != null && sectionBody != null && imageWrapper != null && imageInner != null && hotSpots.length) {
      //       var currIndex = Math.abs(sectionContainer.offsetTop - sectionBody.offsetTop) / (sectionContainer.offsetHeight - sectionBody.offsetHeight);
      //       console.log(currIndex);
      //       imageWrapper.scrollLeft = currIndex * (imageInner.offsetWidth / 2);
      //       // imageWrapper.scroll({
      //       //     left: currIndex * (imageInner.offsetWidth / 2),
      //       //     top: 0,
      //       //     behavior: 'smooth'
      //       // })
      //     }
      //   }
      //  }

      //  window.addEventListener("scroll", throttle(handleScrollAnimation));

      //   window.addEventListener('scroll',function(event) {
      //   if (window.innerWidth < 481) {      
      //     if (sectionContainer != null && sectionBody != null && imageWrapper != null && imageInner != null && hotSpots.length) {
      //       var currIndex = Math.abs(sectionContainer.offsetTop - sectionBody.offsetTop) / (sectionContainer.offsetHeight - sectionBody.offsetHeight);
      //       console.log(currIndex);
      //       imageWrapper.scrollLeft = currIndex * (imageInner.offsetWidth / 2);
      //     }
      //   }
      // });

      

      if (sectionContainer != null && sectionBody != null) {
        sectionBody.style.setProperty('--window-height', window.innerHeight + 'px');
        sectionBody.style.setProperty('--section-height', sectionBody.offsetHeight + 'px');
      }

      window.addEventListener('resize', function(event) {
        if (sectionContainer != null && sectionBody != null) {
          sectionBody.style.setProperty('--window-height', window.innerHeight + 'px');
          sectionBody.style.setProperty('--section-height', sectionBody.offsetHeight + 'px');
        }
      });
    }

    _handleMobileLabelClick({ currentTarget }) {
        if (currentTarget.closest(SPOT_SEL) === this.activeSpot) {
            $active(this.activeSpot, false);
            this.activeSpot = false;
            return;
        };

        this.activeSpot && $active(this.activeSpot, false);
        this.activeSpot = currentTarget.closest(SPOT_SEL);
        $active(this.activeSpot);
    }

    _handleChange({ currentTarget }) {
        this._setActiveCard(currentTarget);
    }

    _setActiveCard(current) {
        if (current === this.activeTrigger) return;

        if (this.activeTrigger) this.activeTrigger.checked = false; 
        this.activeTrigger = current;
    }

    _handleImageClick() {
        if (!this.activeTrigger) return;

        this.activeTrigger.checked = false;
        this.activeTrigger = false;
        this.activeSpot && $active(this.activeSpot, false);
        this.activeSpot = false;
    }
})